import { defineStore } from 'pinia';
import { reactive } from 'vue';

export type MarketingUtm = {
  id?: string;
  term?: string;
  medium?: string;
  source?: string;
  content?: string;
  campaign?: string;
};

export type GoogleClickConversion = {
  gclid?: string;
  gbraid?: string;
  wbraid?: string;
};

export type FacebookClickConversion = {
  fbclid?: string;
  fbc?: string;
  fbp?: string;
};

export type TiktokClickConversion = {
  ttclid?: string;
};

export type AptAttribution = {
  channel?: string;
  content?: string;
  extra?: string;
};

export const useMarketingTrackingStore = defineStore(
  'ap.marketingTracking',
  () => {
    const utm = reactive<MarketingUtm>({});
    const google = reactive<GoogleClickConversion>({});
    const facebook = reactive<FacebookClickConversion>({});
    const tiktok = reactive<TiktokClickConversion>({});
    const apt = reactive<AptAttribution>({});

    const setUtm = (values: MarketingUtm) => {
      utm.id = values.id;
      utm.term = values.term;
      utm.medium = values.medium;
      utm.source = values.source;
      utm.content = values.content;
      utm.campaign = values.campaign;
    };

    const setGoogle = (values: GoogleClickConversion) => {
      if (values.gclid !== undefined) {
        google.gclid = values.gclid;
      }

      if (values.gbraid !== undefined) {
        google.gbraid = values.gbraid;
      }

      if (values.wbraid !== undefined) {
        google.wbraid = values.wbraid;
      }
    };

    const setFacebook = (values: FacebookClickConversion) => {
      if (values.fbclid !== undefined) {
        facebook.fbclid = values.fbclid;
      }

      if (values.fbc !== undefined) {
        facebook.fbc = values.fbc;
      }

      if (values.fbp !== undefined) {
        facebook.fbp = values.fbp;
      }
    };

    const setTiktok = (values: TiktokClickConversion) => {
      if (values.ttclid !== undefined) {
        tiktok.ttclid = values.ttclid;
      }
    };

    const setApt = (values: AptAttribution) => {
      apt.channel = values.channel;
      apt.content = values.content;
      apt.extra = values.extra;
    };

    return {
      utm,
      google,
      facebook,
      tiktok,
      apt,
      setUtm,
      setGoogle,
      setFacebook,
      setTiktok,
      setApt,
    };
  },
  {
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
    },
  },
);
